<template>
    <div id="quotelModal" ref="quotelModal" class="modal fade" tabindex="-1" aria-labelledby="quotelModal"
        aria-hidden="true">
        <div
            class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!px-3 laptop:!w-[500px] mobile:!mx-auto laptop:mx-[unset] mobile:!relative laptop:!absolute mobile:!right-[unset] laptop:!right-4 mobile:!top-[unset] laptop:!top-0 !m-0 h-full">
            <div class="modal-content select-none">
                <div class="modal-body !p-3 !pb-5">
                    <div
                        class="relative w-full mobile:h-[70px] tablet:h-[100px] rounded-lg overflow-hidden flex items-center justify-start">
                        <img src="../../assets/images/profile-bg.png"
                            class="w-full h-full object-cover absolute left-0 top-0" alt="backgroundImage">
                        <h4
                            class="text-xl relative font-medium font-roboto text-left pl-3 flex items-center text-gray-950">
                            Consumer Details
                        </h4>
                        <button type="button" class="absolute right-3 top-3" data-bs-dismiss="modal" aria-label="Close">
                            <font-awesome-icon icon="xmark" class="text-2xl font-light text-red-500" />
                        </button>
                    </div>
                    <div
                        class="responsiveOreitationConsumerHeightAdjust w-full flex flex-col mobile:p-1.5 tablet:p-1 tablet:gap-1 largeDesktop:p-3 largeDesktop:gap-2 mobile:gap-2">
                        <h4 class="laptop:m-0 text-lg font-medium text-red-500">
                            Consumer:
                        </h4>
                        <div class="pt-1">
                            <label for="phoneNumber" class="text-gray-400 pb-1">Phone Number <span
                                    class="text-red-600">*</span></label>
                            <inputComponent ref="phoneRef" v-model="phone" name="phone" required mask="(###) ###-####"
                                placeholder="Enter Number" error-message="Invalid phone number" />
                        </div>
                        <div class="pt-1">
                            <label for="phoneNumber" class="text-gray-400 pb-1">Email</label>

                            <inputComponent ref="emailRef" v-model="email" name="email" :regex="$constants.EMAIL_REGEX"
                                error-message="Please enter a valid email address" placeholder="Enter Email"
                                :disabled="!isConsumerApiCalled" />
                        </div>
                        <div class="pt-1 grid grid-cols-2 gap-2">
                            <div class="col-span-1">
                                <label for="firstName" class="text-gray-400 pb-1">First Name <span
                                        class="text-red-600">*</span></label>
                                <inputComponent ref="firstNameRef" v-model="first_name" name="firstName" required
                                    placeholder="Enter First Name" :disabled="!isConsumerApiCalled" />
                            </div>
                            <div class="col-span-1">
                                <label for="lastName" class="text-gray-400 pb-1">Last Name <span
                                        class="text-red-600">*</span></label>
                                <inputComponent ref="lastNameRef" v-model="last_name" name="lastName" required
                                    placeholder="Enter Last Name" :disabled="!isConsumerApiCalled" />
                            </div>
                        </div>
                        <div>
                            <div class="pt-2 flex justify-between items-center">
                                <span class="text-lg font-medium text-red-500">Address:</span>
                                <button type="button" :disabled="!isConsumerApiCalled"
                                    class="flex justify-between items-center group mobile:px-2 mobile:py-1 tablet:px-3 mobile:gap-2 transition-all text-base mobile:w-auto tablet:w-[150px] mobile:h-auto tablet:h-[40px] rounded-md border shadow-md no-underline focus:outline-0 border-gray-500 text-black-100 hover:bg-red-500 hover:text-white disabled:!bg-[#EFEFEF] disabled:hover:!text-gray-500 disabled:!text-gray-500 disabled:cursor-not-allowed"
                                    @click="toggleDiv">
                                    Add Address
                                    <font-awesome-icon icon="location-dot"
                                        class="mobile:text-lg tablet:text-xl text-red-400  group-hover:text-white disabled:text-gray-500 group-disabled:text-gray-500" />
                                </button>
                            </div>
                            <div v-show="!isVisible"
                                class="my-3 mobile:min-h-[5vh] max-h-[25vh] desktop:max-h-[15vh] overflow-y-auto customScrollbar">
                                <div v-show="!isVisible" class="m-2">
                                    <h6 v-if="addresses == null || (addresses && addresses.length == 0)"
                                        class="text-center m-0 text-gray-400">
                                        No Address Found
                                    </h6>
                                    <div v-for="(addr, index) in addresses" :key="index"
                                        class="mobile:p-2 tablet:p-3 flex items-start gap-2 rounded-lg border mb-2 cursor-pointer"
                                        :class="{
                                            'border-purple-500 ring-2 ring-purple-400': selectedAddress && selectedAddress.id === addr.id,
                                            'border-gray-600': selectedAddress && selectedAddress.id !== addr.id
                                        }" @click="selectedAddress = addr">
                                        <div class="w-full">
                                            <h5 class="text-base text-purple-100 m-0">
                                                Address:
                                            </h5>
                                            <p class="m-0 text-sm">
                                                {{ addr.address_1 }}
                                            </p>

                                            <div v-if="addr.address_2" class="mt-2">
                                                <h5 class="text-base text-purple-100 m-0">
                                                    Address 2:
                                                </h5>
                                                <p class="m-0 text-sm">
                                                    {{ addr.address_2 }}
                                                </p>
                                            </div>
                                        </div>

                                        <div class="w-auto">
                                            <button type="button"
                                                class="w-7 h-7 cursor-pointer flex justify-center items-center rounded-full bg-gray-200"
                                                @click.stop="deleteAddressClicked(addr)">
                                                <img src="../../assets/images/delete-icon-3.png"
                                                    class="w-4 object-contain" alt="">
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="isVisible" ref="scrollableDiv"
                                class="p-3 mt-3 shadow-[0px_0px_10px_0px_#00000026] rounded-lg ">
                                <div ref="addressForm"
                                    class="desktop:max-h-[12vh] largeDesktop:!max-h-[auto] overflow-y-auto customScrollbar">
                                    <div class="pt-1">
                                        <label for="address" class="text-gray-400 pb-1">Address <span
                                                class="text-red-600">*</span></label>
                                        <GoogleAutoComplete v-model="selectedFormattedAddress.address_1"
                                            placeholder="Address" :reset="resetAddress"
                                            :input-class="'w-full p-2 rounded-lg text-gray-600 outline-none text-sm'"
                                            @place-selected="handlePlace" @address-reset="selectedAddress = null" />
                                    </div>
                                    <div class="pt-1">
                                        <label for="address2" class="text-gray-400 pb-1">Address 2</label>
                                        <inputComponent ref="address2Ref" v-model="selectedFormattedAddress.address_2"
                                            name="address2" placeholder="Enter Address 2" />

                                        <!-- <input type="text" name="address2" id="address2" v-model="formData.address2"
                                        class="w-full p-2 rounded-lg border border-gray-600 text-gray-600 outline-none text-sm"> -->
                                    </div>
                                    <div class="pt-1">
                                        <label for="state" class="text-gray-400 pb-1">State <span
                                                class="text-red-600">*</span></label>

                                        <inputComponent ref="stateRef" v-model="selectedFormattedAddress.state_id"
                                            name="state" required placeholder="Enter State" />

                                        <!-- <input type="text" name="state" id="state" required v-model="formData.state"
                                        class="w-full p-2 rounded-lg border border-gray-600 text-gray-600 outline-none text-sm"> -->
                                    </div>
                                    <div class="pt-1 grid grid-cols-2 gap-2">
                                        <div class="col-span-1">
                                            <label for="city" class="text-gray-400 pb-1">City <span
                                                    class="text-red-600">*</span></label>
                                            <inputComponent ref="cityRef" v-model="selectedFormattedAddress.city_id"
                                                name="city" required placeholder="Enter City" />


                                            <!-- <input type="text" name="city" id="city" required v-model="formData.city"
                                            class="w-full p-2 rounded-lg border border-gray-600 text-gray-600 outline-none text-sm"> -->
                                        </div>
                                        <div class="col-span-1">
                                            <label for="zipCode" class="text-gray-400 pb-1">Zip Code <span
                                                    class="text-red-600">*</span></label>
                                            <inputComponent ref="zipCodeRef"
                                                v-model="selectedFormattedAddress.postal_code" name="zipCode" required
                                                placeholder="Enter Zip Code" />

                                            <!-- <input type="number" name="zipCode" id="zipCode" required
                                            v-model="formData.zipCode"
                                            class="w-full p-2 rounded-lg border border-gray-600 text-gray-600 outline-none text-sm"> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="flex justify-center gap-3 pt-3">
                                    <button type="button"
                                        class="mobile:w-[80px] mobile:h-[35px] tablet:w-[100px] tablet:h-[40px] flex justify-center items-center rounded-lg bg-red-400 hover:bg-red-500 text-white"
                                        @click="cancelAddressClicked">
                                        Back
                                    </button>
                                    <button type="button" :disabled="isAddAddressValid"
                                        class="mobile:w-[80px] mobile:h-[35px] tablet:w-[100px] tablet:h-[40px] flex justify-center items-center rounded-lg bg-secondary-100 text-white hover:opacity-90 disabled:bg-[#999] disabled:text-gray-500"
                                        @click="saveAddress">
                                        Add
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="!isVisible" class="mobile:pb-2 tablet:pb-4 px-3 flex justify-center ">
                        <div class="flex justify-center gap-3">
                            <button type="button" data-bs-dismiss="modal" aria-label="Close"
                                class="mobile:w-[80px] mobile:h-[35px] tablet:w-[100px] tablet:h-[40px] flex justify-center items-center rounded-lg bg-red-400 hover:bg-red-500 text-white">
                                Cancel
                            </button>
                            <button type="button" :disabled="!validate"
                                class="mobile:w-[80px] mobile:h-[35px] tablet:w-[100px] tablet:h-[40px] flex justify-center items-center rounded-lg bg-secondary-100 text-white hover:opacity-90 disabled:cursor-not-allowed disabled:bg-gray-400 disabled:text-gray-600"
                                @click="submitForm">
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap';
import inputComponent from '../partialComponent/inputComponent.vue';
import { mapActions, mapGetters } from "vuex";
import { ref } from 'vue';
import { useToast } from "vue-toastification";
import GoogleAutoComplete from '../partialComponent/GoogleAutoComplete.vue';
import { has } from 'lodash';
const toast = useToast();

export default {
    components: {
        inputComponent,
        GoogleAutoComplete
    },
    props: ["submitClicked"],
    data() {
        return {
            email: null,
            phone: null,
            first_name: null,
            last_name: null,
            isConsumerApiCalled: false,
            isConsumerFound: false,
            selectedAddress: null,
            deletedAddress: null,
            addresses: null,
            selectedFormattedAddress: {
                address_1: null,
                address_2: null,
                postal_code: null,
                city_id: null,
                state_id: null
            },
            isVisible: false,
            phoneRef: ref(null),
            firstNameRef: ref(null),
            lastNameRef: ref(null),
            emailRef: ref(null),
        };
    },
    computed: {
        ...mapGetters([
            "consumerDetails",
            "consumerAddresses",
            "deleteAddressResponse",
            "formattedAddress",
            "consumerAddressStoreResponse",
            "addConsumerResponse"
        ]),
        validate() {
            return (
                !this.$refs.phoneRef?.hasError() &&
                !this.$refs.firstNameRef?.hasError() &&
                !this.$refs.lastNameRef?.hasError() &&
                !this.$refs.emailRef?.hasError()
            );
        },
        isAddAddressValid() {
            return (
                this.selectedFormattedAddress.address_1 == null ||
                this.selectedFormattedAddress.address_2 == null ||
                this.selectedFormattedAddress.state_id == null ||
                this.selectedFormattedAddress.city_id == null ||
                this.selectedFormattedAddress.postal_code == null || this.validateRefFields()
            )
        }
    },
    watch: {
        phone: function (data) {
            const digits = this.phone?.replace(/\D/g, '') ?? "";
            if (digits.length == 10) {
                this.getConsumerDetails({
                    phone: this.phone
                })
            }
            else {
                this.resetDataExceptPhone()
            }
        },

        consumerDetails: function (data) {
            this.resetRefs()
            this.isConsumerApiCalled = true
            this.isConsumerFound = this.consumerDetails.company_consumer_id == 0 ? false : true
            this.selectedAddress = null
            this.deletedAddress = null
            this.addresses = null
            this.selectedFormattedAddress = {
                address_1: null,
                address_2: null,
                postal_code: null,
                city_id: null,
                state_id: null
            },
                this.isVisible = false
            this.setConsumer()
        },

        consumerAddresses: function (data) {
            this.addresses = this.consumerAddresses
        },

        deleteAddressResponse: function (data) {
            if ((this.deletedAddress && this.deletedAddress.id) == (this.selectedAddress && this.selectedAddress.id)) {
                this.selectedAddress = null
                this.deletedAddress = null
            }
            this.getConsumerAddresses({
                company_consumer_id: this.consumerDetails.company_consumer_id
            })
        },

        formattedAddress: function (data) {
            console.log("selectedFormattedAddress", this.formattedAddress);

            this.selectedFormattedAddress = this.formattedAddress
        },

        consumerAddressStoreResponse: function (data) {
            if (this.isConsumerFound) {
                toast.success("Address has been added successfully.")
                this.isVisible = false;
                this.getConsumerAddresses({
                    company_consumer_id: this.consumerDetails.company_consumer_id
                })
            } else {
                this.submitClicked({
                    consumer_id: this.consumerDetails.consumer_id,
                    address_id: this.consumerAddressStoreResponse[0].id,
                    email: this.email.trim(),
                    first_name: this.first_name.trim(),
                    last_name: this.last_name.trim(),
                })
            }
        },

        addConsumerResponse: function (data) {
            this.consumerDetails.company_consumer_id = this.addConsumerResponse.consumer.id
            this.consumerDetails.consumer_id = this.addConsumerResponse.consumer.consumer_id
            this.saveConsumerAddress()
        },
        isVisible(newVal) {
            this.$nextTick(() => {
                const el = this.$refs.addressForm;
                if (el) {
                    // Clean up old listener if it exists
                    el.removeEventListener('scroll', this.onScrollHandler);
                    if (newVal) {
                        this.onScrollHandler(); // optional initial call
                        el.addEventListener('scroll', this.onScrollHandler);
                    }
                }
            });
        }
    },
    mounted() {
    },
    beforeUnmount() {
        const el = this.$refs.addressForm;
        if (el) {
            el.removeEventListener('scroll', this.onScrollHandler);
        }
    },
    methods: {
        onScrollHandler() {
            const pacContainers = document.querySelectorAll('.pac-container');
            pacContainers.forEach(pac => {
                pac.style.display = 'none';
            });
        },
        ...mapActions([
            "getConsumerDetails",
            "getConsumerAddresses",
            "deleteAddress",
            "getFormattedAddress",
            "addConsumerAddress",
            "storeConsumer"
        ]),
        cancelAddressClicked() {
            this.isVisible = false
            this.selectedFormattedAddress = {
                address_1: null,
                address_2: null,
                postal_code: null,
                city_id: null,
                state_id: null
            }
        },
        toggleDiv() {
            this.isVisible = true;
            this.$nextTick(() => {
                const el = this.$refs.scrollableDiv;
                console.log("scrollableDiv", el);
                if (el) el.scrollTop = 0;
            });

        },
        submitForm() {
            if (!this.validateForm()) {
                this.submitClicked({
                    consumer_id: this.consumerDetails.consumer_id,
                    address_id: this.selectedAddress.id,
                    email: this.email.trim(),
                    first_name: this.first_name.trim(),
                    last_name: this.last_name.trim(),
                })
            }
        },
        saveAddress() {
            if (this.selectedFormattedAddress.lat) {
                if (this.isConsumerFound) {
                    this.saveConsumerAddress()
                } else {
                    if (this.validateRefFields()) {
                        // toast.error("Please fill all required fields.");
                    } else {
                        this.saveConsumer()
                    }
                }
            } else {
                toast.error("Please select address.");
            }
            // this.isVisible = false;
        },
        saveConsumerAddress() {
            this.addConsumerAddress({
                "company_consumer_id": this.consumerDetails.company_consumer_id,
                "address_1": this.selectedFormattedAddress.address_1,
                "street": this.selectedFormattedAddress.street,
                "address_2": this.selectedFormattedAddress.address_2,
                "city_id": this.selectedFormattedAddress.city_id,
                "state_id": this.selectedFormattedAddress.state_id,
                "postal_code": this.selectedFormattedAddress.postal_code,
                "country": this.selectedFormattedAddress.country_name,
                "lat": this.selectedFormattedAddress.lat,
                "long": this.selectedFormattedAddress.long
            })
        },
        saveConsumer() {
            this.storeConsumer({
                "first_name": this.first_name.trim(),
                "last_name": this.last_name.trim(),
                "phone": this.phone,
                "email": this.email.trim()

            })
        },
        deleteAddressClicked(address) {
            this.$confirmDialog.show({
                image: 'delete-confirm-icon.svg',
                title: "Delete Address",
                text: "Are you sure you want to delete this address?",
                onConfirm: () => {
                    this.deletedAddress = address
                    this.deleteAddress({
                        id: address.id
                    })
                },
            });
        },

        validateRefFields() {
            let inputRefer = ["phoneRef", "firstNameRef", "lastNameRef", "emailRef"]
            let hasError = false;
            inputRefer.forEach(ref => {
                const component = this.$refs[ref];
                const inputComponent = Array.isArray(component) ? component[0] : component;
                if (inputComponent && typeof inputComponent.validate === "function") {
                    inputComponent.validate();
                    if (inputComponent.hasError()) {
                        hasError = true;
                    }
                }
            });

            return hasError
        },

        validateForm() {
            let inputRefer = ["phoneRef", "firstNameRef", "lastNameRef", "emailRef"]
            let hasError = false;
            inputRefer.forEach(ref => {
                const component = this.$refs[ref];
                const inputComponent = Array.isArray(component) ? component[0] : component;
                if (inputComponent && typeof inputComponent.validate === "function") {
                    inputComponent.validate();
                    if (inputComponent.hasError()) {
                        hasError = true;
                    }
                }
            });

            if (
                this.$helper.isEmpty(this.phone) ||
                this.$helper.isEmpty(this.first_name) ||
                this.$helper.isEmpty(this.last_name) ||
                !this.isConsumerFound
            ) {
                // toast.error("Please fill all required fields.");
                hasError = true;
            }

            if (this.selectedAddress === null) {
                toast.error("Please select address.")
                hasError = true;
            }

            return hasError;

        },
        showModal() {
            this.reset()
            const { Modal } = require('bootstrap');
            const modalEl = this.$refs.quotelModal;
            this.modal = Modal.getInstance(modalEl);
            if (!this.modal) {
                this.modal = new Modal(modalEl, {
                    backdrop: 'static',
                    keyboard: false
                });
            }
            // Add event listeners for show/hide
            modalEl.addEventListener('show.bs.modal', () => {
                document.documentElement.style.overflow = 'hidden'; // Target HTML element
                if (window.innerWidth >= 992) {
                    document.documentElement.style.paddingRight = '15px';
                } else {
                    document.documentElement.style.paddingRight = '0px';
                }
                this.adjustConsumerModalHeight();
            });
            modalEl.addEventListener('hidden.bs.modal', () => {
                document.documentElement.style.overflow = ''; // Reset HTML element
                document.documentElement.style.paddingRight = '0px';
                window.removeEventListener('resize', this.adjustConsumerModalHeight);
                window.removeEventListener('orientationchange', this.adjustConsumerModalHeight);
            });
            window.addEventListener('resize', this.adjustConsumerModalHeight);
            window.addEventListener('orientationchange', this.adjustConsumerModalHeight);
            this.modal.show();
        },
        hideModal() {
            this.reset()
            if (this.modal) {
                this.modal.hide();
            }
        },
        setConsumer() {
            this.first_name = this.consumerDetails.first_name
            this.last_name = this.consumerDetails.last_name
            this.email = this.consumerDetails.email
            this.addresses = null
            if (this.isConsumerFound) {
                this.getConsumerAddresses({
                    company_consumer_id: this.consumerDetails.company_consumer_id
                })
            }
        },
        resetAddress() {

        },
        handlePlace(place) {
            console.log(place);
            this.getFormattedAddress({
                address: place.formatted_address,
                lat: place.geometry?.location?.lat(),
                lng: place.geometry?.location?.lng(),
            })
        },

        resetRefs() {
            let inputRefer = ["phoneRef", "firstNameRef", "lastNameRef", "emailRef"]
            inputRefer.forEach(ref => {
                const component = this.$refs[ref];
                const inputComponent = Array.isArray(component) ? component[0] : component;
                if (inputComponent && typeof inputComponent.resetField === "function") {
                    inputComponent.resetField();
                }
            });
        },
        resetDataExceptPhone() {
            this.resetRefs()
            this.email = null
            this.first_name = null
            this.last_name = null
            this.isConsumerApiCalled = false
            this.isConsumerFound = false
            this.selectedAddress = null
            this.deletedAddress = null
            this.addresses = null
            this.selectedFormattedAddress = {
                address_1: null,
                address_2: null,
                postal_code: null,
                city_id: null,
                state_id: null
            },
                this.isVisible = false
        },
        reset() {
            this.resetRefs()
            this.phone = null
            this.email = null
            this.first_name = null
            this.last_name = null
            this.isConsumerApiCalled = false
            this.isConsumerFound = false
            this.selectedAddress = null
            this.deletedAddress = null
            this.addresses = null
            this.selectedFormattedAddress = {
                address_1: null,
                address_2: null,
                postal_code: null,
                city_id: null,
                state_id: null
            },
                this.isVisible = false
        },
        adjustConsumerModalHeight() {
            const modalContent = this.$refs.quotelModal?.querySelector('.responsiveOreitationConsumerHeightAdjust');
            if (modalContent) {
                const vh = window.innerHeight;
                const vw = window.innerWidth;
                let maxHeight;
                if (vw < 400) {
                    maxHeight = vh * 0.5 - 40;
                } else if (vw < 575) {
                    maxHeight = vh * 0.8 - 40;
                } else if (vw < 750) {
                    maxHeight = vh * 0.5 - 40;
                } else if (vw < 768) {
                    maxHeight = vh * 0.9 - 40;
                } else if (vw < 850) {
                    maxHeight = vh * 0.9 - 40;
                } else if (vw < 950) {
                    maxHeight = vh * 0.5 - 30;
                } else if (vw < 1024) {
                    maxHeight = vh * 0.8 - 30;
                } else if (vw < 1200) {
                    maxHeight = vh * 0.8 - 30;
                } else {
                    maxHeight = vh * 0.8 - 40;
                }
                modalContent.style.maxHeight = `${maxHeight}px`;
                modalContent.style.overflowY = 'auto';
            }
        },
    },
};
</script>